export default __webpack_public_path__ + "static/media/level.77c6f9cf.png";